'use client';

import { DynamicLmnDsThemeProvider, pinkPantherTokens, pinkPantherKallistoTokens } from '@lmn/design-system';
import React, { ReactNode } from 'react';
import { StyledComponentsRegistry } from '@/lib/StyledComponentsRegistry';
import { kallistoMixins } from '@/lib/kallistoMixins';

const kallistoTheme = {
  light: { ...pinkPantherKallistoTokens.light, mixins: kallistoMixins },
  dark: { ...pinkPantherKallistoTokens.dark, mixins: kallistoMixins },
};

type Props = {
  children: ReactNode;
};

export function Providers({ children }: Props) {
  return (
    <StyledComponentsRegistry>
      <DynamicLmnDsThemeProvider themeTokens={pinkPantherTokens} kallistoTheme={kallistoTheme}>
        {children}
      </DynamicLmnDsThemeProvider>
    </StyledComponentsRegistry>
  );
}
